import { render, staticRenderFns } from "./EmailRedirect.vue?vue&type=template&id=a5b7b138&scoped=true&"
import script from "./EmailRedirect.vue?vue&type=script&lang=js&"
export * from "./EmailRedirect.vue?vue&type=script&lang=js&"
import style0 from "./EmailRedirect.vue?vue&type=style&index=0&id=a5b7b138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b7b138",
  null
  
)

export default component.exports